/*
 Contains all the dev parameters for the server. Dont alter this file unless you know the consequences
*/

const dev = {
  dev: false,
  firebase: true, // production: true
  verbose: false, // production: false
}

module.exports = dev
